<!--CC: Selective Mailbox Protection - shared by Plan Settings > Email Flow Integration and the onboarding wizard ("Protected Mailboxes" sub-step)-->
<ng-container *ngIf="relay">
	<div class="title-section-container flex-column gap-2">
		<b *ngIf="!hideTitle">Selective Mailbox Protection (optional)</b>
		<span class="lh-base" style="font-size: 0.9em;" *ngIf="!hideTitle">
			Enter specific addresses here if you want to enable protection for <b>these mailboxes only</b>. If this field is empty, <b>all</b> mailboxes under your mail server will be protected.
		</span>
		<span class="lh-base" style="font-size: 0.9em;" *ngIf="relay.addresses_only?.length">
			<b>{{relay.addresses_only.length}}</b> mailbox{{relay.addresses_only.length > 1 ? 'es' : ''}} listed - only these mailboxes are protected and use Inbound Shield licenses. Emails to other mailboxes are delivered to your mail server without scanning.
		</span>

		<div class="flex-row align-items-center gap-2">
			<span>Skip sending email to unlisted mailboxes</span>
			<i class="far fa-info-circle text-muted" style="cursor: help;"
			   tooltip="When enabled, emails addressed to mailboxes that are not listed are NOT delivered at all. When disabled (default), they are delivered to your mail server without scanning. Available once the list is not empty."></i>
			<toggle-switch-c id="{{idPrefix}}addresses_only_skip_mode"
							 [hideText]="true"
							 [(model)]="relay.addresses_only_skip_mode"
							 (onChange)="updateSkipMode();"
							 [isDisabled]="!relay.addresses_only?.length || inProcess"></toggle-switch-c>
		</div>
	</div>
	<div class="content-container flex-column gap-2">
		<div class="flex-row gap-1">
			<input type="text" style="width: 52%; margin: 0;"
				   placeholder="Mailbox address"
				   (keyup.enter)="addAddress();"
				   [(ngModel)]="newAddress">
			<btn-c style="min-width: 0;"
				   endIcon="zmdi zmdi-check"
				   [isDisabled]="!newAddress || inProcess"
				   (action)="addAddress();">
			</btn-c>
			<btn-c (action)="addAddressesFromFile();" endIcon="far fa-file-import" style="min-width: 0;"
				   [isDisabled]="inProcess"
				   tooltip="Import addresses from csv (Emails column)">
			</btn-c>
		</div>
		<div style="padding-right: 6px; overflow: auto; max-height: 200px; max-width: 420px;">
			<div *ngFor="let address of relay.addresses_only"
				 class="flxRow"
				 style="margin-bottom: 10px; justify-content: space-between;">
				<div class="name ellipsis"
					 style="display: inline-block;">{{address}}</div>
				<a class="closeRed action"
				   (click)="removeAddress(address)"
				   [ngClass]="inProcess ? 'closeRed disableAction' : 'approveGreen'">
					<i class="far fa-times"></i>
				</a>
			</div>
		</div>
	</div>
</ng-container>
